import WebFont from 'webfontloader'

export function useGoogleFonts() {
  const loadFonts = (fonts: string[]) => {
    if (!fonts || fonts.length === 0) return

    return new Promise((resolve, reject) => {
      WebFont.load({
        google: {
          families: fonts,
          display: 'swap',
        },
        active: () => resolve(true),
        inactive: () => reject(new Error('Failed to load fonts')),
      })
    })
  }

  const extractUniqueFonts = (
    settings: Record<string, unknown> | undefined,
  ): string[] => {
    const fonts = new Set<string>()

    if (!settings) return Array.from(fonts)

    const primaryCTA = settings.primaryCTA as
      | { typography?: { fontFamily?: string } }
      | undefined
    if (primaryCTA?.typography?.fontFamily) {
      const ctaFont = primaryCTA.typography.fontFamily.split(',')[0].trim()
      if (!isSystemFont(ctaFont)) {
        fonts.add(ctaFont)
      }
    }

    const secondaryCTA = settings.secondaryCTA as
      | { typography?: { fontFamily?: string } }
      | undefined
    if (secondaryCTA?.typography?.fontFamily) {
      const ctaFont = secondaryCTA.typography.fontFamily.split(',')[0].trim()
      if (!isSystemFont(ctaFont)) {
        fonts.add(ctaFont)
      }
    }

    return Array.from(fonts)
  }

  const isSystemFont = (font: string): boolean => {
    const systemFonts = [
      'Arial',
      'Helvetica',
      'Times New Roman',
      'Times',
      'Courier New',
      'Courier',
      'Verdana',
      'Georgia',
      'system-ui',
      '-apple-system',
    ]
    return systemFonts.some(systemFont =>
      font.toLowerCase().includes(systemFont.toLowerCase()),
    )
  }

  return {
    loadFonts,
    extractUniqueFonts,
  }
}
